(function () {
  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function money(cents) {
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2);
    }
  }

  function padQty(scope) {
    (scope || document).querySelectorAll('.vl-cart__qty-input').forEach(function (input) {
      if (input.dataset.padded === '1') return;
      const n = parseInt(input.value, 10);
      if (!Number.isNaN(n) && n < 10) input.value = '0' + n;
      input.dataset.padded = '1';
    });
  }

  function removeLine(item) {
    if (!item || item.dataset.vlRemoving === '1') return;
    const trigger = item.querySelector('cart-remove-button a, cart-remove-button button');
    if (!trigger) return;
    item.dataset.vlRemoving = '1';
    trigger.click();
  }

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest && event.target.closest('cart-drawer .vl-cart__qty-btn[name="minus"]');
      if (!button) return;

      const item = button.closest('.vl-cart__item');
      const input = item ? item.querySelector('.vl-cart__qty-input') : null;
      if (!input) return;

      const current = parseInt(input.value, 10) || 0;
      const step = parseInt(input.step, 10) || 1;
      const min = Math.max(parseInt(input.dataset.min, 10) || 1, 1);
      if (current - step >= min) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      removeLine(item);
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      const input = event.target.closest && event.target.closest('cart-drawer .vl-cart__qty-input');
      if (!input || input.value.trim() === '') return;
      if ((parseInt(input.value, 10) || 0) > 0) return;

      event.stopImmediatePropagation();
      removeLine(input.closest('.vl-cart__item'));
    },
    true
  );

  function updateShipBar(scope) {
    const bar = (scope || document).querySelector('[data-vl-ship]');
    if (!bar) return;
    const threshold = Number(bar.dataset.threshold) || 0;
    if (threshold <= 0) return;

    return fetch(shopRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        const total = cart.total_price;
        const fill = bar.querySelector('[data-vl-ship-fill]');
        const text = bar.querySelector('[data-vl-ship-text]');
        const remaining = bar.querySelector('[data-vl-ship-remaining]');
        const pct = Math.min(100, Math.round((total / threshold) * 100));

        if (fill) fill.style.width = pct + '%';

        if (total >= threshold) {
          if (text && bar.dataset.success) {
            const icon = text.querySelector('.vl-cart__ship-icon');
            text.textContent = bar.dataset.success;
            if (icon) text.prepend(icon);
          }
        } else if (remaining) {
          remaining.textContent = money(threshold - total);
        }
      })
      .catch(function () {});
  }

  function refresh() {
    updateShipBar(document);
    padQty(document);
  }

  let pending;
  function refreshSoon() {
    clearTimeout(pending);
    pending = setTimeout(refresh, 60);
  }

  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('vl:cart:added', refreshSoon);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refreshSoon);
  }

  const drawer = document.querySelector('cart-drawer');
  if (drawer && typeof MutationObserver !== 'undefined') {
    let muted = false;

    const observer = new MutationObserver(function (records) {
      if (muted) return;

      const relevant = records.some(function (record) {
        const target = record.target;
        if (!target || target.nodeType !== 1) return false;
        return !target.closest('[data-vl-ship]');
      });
      if (!relevant) return;

      muted = true;
      refreshSoon();
      setTimeout(function () {
        muted = false;
      }, 300);
    });

    observer.observe(drawer, { childList: true, subtree: true });
  }

  if (!customElements.get('vl-cart-recommendations')) {
    customElements.define(
      'vl-cart-recommendations',
      class VlCartRecommendations extends HTMLElement {
        static cache = null;

        connectedCallback() {
          if (VlCartRecommendations.cache) {
            this.innerHTML = VlCartRecommendations.cache;
            this.hydrate();
            return;
          }
          this.load();
        }

        async load() {
          const base = this.dataset.url;
          if (!base) return;

          let html = await this.fetchSection(base);
          if (!this.hasItems(html)) {
            html = await this.fetchSection(base.replace('intent=complementary', 'intent=related'));
          }
          if (!this.hasItems(html)) return;

          this.innerHTML = html;
          VlCartRecommendations.cache = html;
          this.hydrate();
        }

        async fetchSection(url) {
          try {
            const res = await fetch(url);
            if (!res.ok) return '';
            const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
            const section = doc.querySelector('.shopify-section');
            return section ? section.innerHTML : '';
          } catch {
            return '';
          }
        }

        hasItems(html) {
          return !!html && html.includes('vl-cart__cross-item');
        }

        hydrate() {
          this.wireAdds();
          this.wireNav();
        }

        wireAdds() {
          this.querySelectorAll('.vl-cart__cross-add').forEach((btn) => {
            btn.addEventListener('click', async () => {
              const id = Number(btn.dataset.variantId);
              if (!id) return;
              btn.setAttribute('aria-busy', 'true');
              try {
                const res = await fetch(routes.cart_add_url, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
                  body: JSON.stringify({
                    items: [{ id, quantity: 1 }],
                    sections: 'cart-drawer,cart-icon-bubble',
                    sections_url: window.location.pathname,
                  }),
                });
                const state = await res.json();
                const drawerEl = document.querySelector('cart-drawer');
                if (drawerEl && state.sections) drawerEl.renderContents(state);
              } finally {
                btn.removeAttribute('aria-busy');
              }
            });
          });
        }

        wireNav() {
          const track = this.querySelector('.vl-cart__cross-track');
          if (!track) return;
          const prev = this.querySelector('[data-vl-cross-prev]');
          const next = this.querySelector('[data-vl-cross-next]');
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

          const items = () => Array.from(track.querySelectorAll('.vl-cart__cross-item'));
          const isScrollable = () => track.scrollWidth > track.clientWidth + 1;

          const step = () => {
            const item = track.querySelector('.vl-cart__cross-item');
            return item ? item.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
          };

          const sync = () => {
            track.classList.toggle('is-scrollable', isScrollable());
            if (prev) prev.toggleAttribute('disabled', track.scrollLeft <= 1);
            if (next) next.toggleAttribute('disabled', track.scrollLeft + track.clientWidth >= track.scrollWidth - 1);
          };

          if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
          if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));

          const offsetFor = (item) => {
            const target = track.scrollLeft + item.getBoundingClientRect().left - track.getBoundingClientRect().left;
            return Math.max(0, Math.min(target, track.scrollWidth - track.clientWidth));
          };

          const nearestIndex = () => {
            let nearest = 0;
            let best = Infinity;
            items().forEach((item, i) => {
              const distance = Math.abs(offsetFor(item) - track.scrollLeft);
              if (distance < best) {
                best = distance;
                nearest = i;
              }
            });
            return nearest;
          };

          let drag = null;
          let suppressClick = false;
          let clickTimer;
          let settleTimer;

          const settleTo = (left) => {
            track.classList.add('is-settling');
            track.scrollTo({ left, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
            clearTimeout(settleTimer);
            settleTimer = setTimeout(() => {
              track.classList.remove('is-settling');
              sync();
            }, 450);
          };

          const endDrag = (e) => {
            const d = drag;
            if (!d || e.pointerId !== d.id) return;
            drag = null;
            if (!d.moved) return;

            track.classList.remove('is-dragging');
            suppressClick = true;
            clearTimeout(clickTimer);
            clickTimer = setTimeout(() => {
              suppressClick = false;
            }, 60);

            const list = items();
            if (!list.length) return;
            const dx = d.lastX - d.x;
            const threshold = Math.min(60, list[0].offsetWidth * 0.2);
            let target = nearestIndex();
            if (target === d.start && Math.abs(dx) > threshold) {
              target = dx < 0 ? d.start + 1 : d.start - 1;
            }
            target = Math.max(0, Math.min(target, list.length - 1));
            settleTo(offsetFor(list[target]));
          };

          track.addEventListener('pointerdown', (e) => {
            if (!isScrollable()) return;
            if (e.pointerType === 'mouse' && e.button !== 0) return;
            drag = {
              id: e.pointerId,
              x: e.clientX,
              y: e.clientY,
              lastX: e.clientX,
              left: track.scrollLeft,
              start: nearestIndex(),
              moved: false,
            };
          });

          track.addEventListener('pointermove', (e) => {
            const d = drag;
            if (!d || e.pointerId !== d.id) return;
            const dx = e.clientX - d.x;
            const dy = e.clientY - d.y;
            if (!d.moved) {
              if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
              if (Math.abs(dy) > Math.abs(dx)) {
                drag = null;
                return;
              }
              d.moved = true;
              clearTimeout(settleTimer);
              track.classList.remove('is-settling');
              track.classList.add('is-dragging');
              try {
                track.setPointerCapture(d.id);
              } catch (err) {}
            }
            e.preventDefault();
            d.lastX = e.clientX;
            track.scrollLeft = d.left - dx;
          });

          track.addEventListener('pointerup', endDrag);
          track.addEventListener('pointercancel', endDrag);
          track.addEventListener('lostpointercapture', endDrag);
          track.addEventListener('dragstart', (e) => e.preventDefault());
          track.addEventListener(
            'click',
            (e) => {
              if (!suppressClick) return;
              e.preventDefault();
              e.stopPropagation();
            },
            true
          );

          track.addEventListener('scroll', sync, { passive: true });

          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (typeof ResizeObserver !== 'undefined') {
            this.resizeObserver = new ResizeObserver(sync);
            this.resizeObserver.observe(track);
          }

          sync();
        }

        disconnectedCallback() {
          if (this.resizeObserver) this.resizeObserver.disconnect();
        }
      }
    );
  }
})();